import 'uni-pages';import 'uni-h5';import '@dcloudio/uni-stat/dist/uni-stat.es.js';import Vue from 'vue'
import App from './App'
import store from './store'
import globalConfig from './utils/config'
import util from './utils/util'

// 全局静态文件地址
Vue.prototype.__staticHost = globalConfig.staticHost
Vue.config.productionTip = false

Vue.prototype.$store = store

const oldGetApp = getApp

getApp = () => {
    if (oldGetApp() && oldGetApp().$vm) {
        return oldGetApp().$vm
    }
    return oldGetApp()
}


const oldGetStorageSync = uni.getStorageSync
uni.getStorageSync = (args) => {
    try {
        if( typeof args === 'string') return oldGetStorageSync(args)
        else return ''
    } catch (error) {
        return ''
    }
}

const checkH5OpenId = ()=>{
    // 微信内必须要有openid
    console.log('checkH5OpenId')
    let appt =getApp()
    let openId = appt ? appt.globalData.wxConfig.openId : ''
    if(util.isWeiXin() && !openId){
        // 获取openid超过2次后不再获取
        let openIdNumber = Number(uni.getStorageSync('openIdNumber') || 0)
        if(openIdNumber && openIdNumber > 2){
            return false
        }
        let pages = getCurrentPages()
        console.log('微信内必须要有openid',pages)
        let url = '/pages/index/index'
        let path = 'pages/index/index'
        let viewurl = ''
        let filterRoute = ['pages/index/index','pages/login/login','pages/login/reg','pages/login/pwd','pagespacka/webView/chooseSeat', 'pagespacka/webView/chooseSeatForTikTok']
        if(pages && pages.length>0){
            path = pages[pages.length-1].route
            viewurl =  '/' + path + window.location.search
        }
        if(viewurl) url = url + '?viewurl=' + encodeURIComponent(viewurl)
        if(path && filterRoute.indexOf(path)<0){
            uni.setStorageSync('openIdNumber',openIdNumber + 1)
            // 除了过滤页面都要有openid
            uni.redirectTo({
                url: url
            })
        }
    } else {
        uni.setStorageSync('openIdNumber',0)
    }
}

Vue.mixin({
    beforCreate: function () {
        let appt =getApp()
        if(appt && document && appt.globalData.theaterInfo) document.title = appt.globalData.theaterInfo.Name || '';
    },
    onLoad:function(option){
        let appt =getApp()
        if(option&&option.ChannelId){
            appt.globalData.ChannelId = option.ChannelId
            uni.hideTabBar()
        }else{
            appt.globalData.ChannelId = ''
            uni.showTabBar()
        }
    },
    onShow: function () {
        let appt =getApp()
        if(appt && document && appt.globalData.theaterInfo) document.title = appt.globalData.theaterInfo.Name || ''

        checkH5OpenId()

    },
})

App.mpType = 'app'

const app = new Vue({
    store,
    ...App
})
app.$mount()